export const API_BASE_URL = 'https://api.joyntapp.com'; // Adjust as needed
// export const API_BASE_URL = 'http://localhost:5001'; // Adjust as needed
export const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('accessToken') || ''}`, // Use token from localStorage if available
    },
    // withCredentials: true, // Include credentials for cross-origin requests
};